var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPillImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.527,
    height: 19.524,
    viewBox: "0 0 19.527 19.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u110B\\u1165\\u11B8\\u1106\\u116E\\u110B\\u1175\\u11AF\\u110C\\u1175",
    d: "M19.526,18.811a.765.765,0,0,1-.763.763h-9a.763.763,0,1,1,0-1.525h9A.765.765,0,0,1,19.526,18.811Zm-.763-3.764h-6a.763.763,0,1,0,0,1.525h6a.763.763,0,1,0,0-1.525Zm0-3h-3a.763.763,0,0,0,0,1.525h3a.763.763,0,1,0,0-1.525Zm.538-6.2L5.8,19.349a.756.756,0,0,1-.538.225H.763A.765.765,0,0,1,0,18.811v-4.5a.75.75,0,0,1,.225-.538l13.5-13.5a.764.764,0,0,1,1.079,0l4.5,4.5A.756.756,0,0,1,19.3,5.849Zm-1.617-.538L14.263,1.89,1.525,14.628v3.421H4.946Z",
    transform: "translate(0 -0.05)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillImg2);
export default __webpack_public_path__ + "static/media/pill_img_2.a38d72569cc18ea1acd108fe916172c3.svg";
export { ForwardRef as ReactComponent };